export default __webpack_public_path__ + "static/media/m4.5b8cfd8b.jpg";